export default __webpack_public_path__ + "static/media/icon-logo.58291d6e.svg";